import React from 'react'
import Sketch from 'react-p5'

import LocalizedStrings from 'react-localization';
import {LanguageContext} from "./LanguageContext"

import p5 from "p5";

let strings = new LocalizedStrings({
    en:{
        title:"birds",
        description:""
    },
    de: {
        title:"vögel",
        description:""
    }
});

// The Nature of Code
// Daniel Shiffman
// http://natureofcode.com

// Flock object
// Does very little, simply manages the array of all the boids

function Flock() {
	// An array for all the boids
	this.boids = []; // Initialize the array
}

Flock.prototype.run = function(p5) {
	for (let i = 0; i < this.boids.length; i++) {
		this.boids[i].run(p5, this.boids); // Passing the entire list of boids to each boid individually
	}
}

Flock.prototype.addBoid = function(b) {
	this.boids.push(b);
}

// The Nature of Code
// Daniel Shiffman
// http://natureofcode.com

// Boid class
// Methods for Separation, Cohesion, Alignment added

function Boid(_p5, x, y, ch, maxSpeed, maxForce) {
	this.acceleration = _p5.createVector(0, 0);
	this.velocity = _p5.createVector(_p5.random(-2, 2), _p5.random(-2, 2));
	this.position = _p5.createVector(x, y);
	this.r = 3.0;
	this.maxspeed = maxSpeed // Maximum speed
	this.maxforce = maxForce // Maximum steering force
    this.char = ch
}

Boid.prototype.run = function(p5, boids) {
	this.flock(p5, boids);
	this.update(p5);
	this.borders(p5);
	this.render(p5);
}

Boid.prototype.applyForce = function(force) {
	// We could add mass here if we want A = F / M
	this.acceleration.add(force);
}

// We accumulate a new acceleration each time based on three rules
Boid.prototype.flock = function(p5, boids) {
	let sep = this.separate(p5, boids); // Separation
	let ali = this.align(p5, boids); // Alignment
	let coh = this.cohesion(p5, boids); // Cohesion
	// Arbitrarily weight these forces
	sep.mult(1.5);
	ali.mult(1.0);
	coh.mult(1.0);
	// Add the force vectors to acceleration
	this.applyForce(sep);
	this.applyForce(ali);
	this.applyForce(coh);
}

// Method to update location
Boid.prototype.update = function() {
	// Update velocity
	this.velocity.add(this.acceleration);
	// Limit speed
	this.velocity.limit(this.maxspeed);
	this.position.add(this.velocity);
	// Reset accelertion to 0 each cycle
	this.acceleration.mult(0);
}

// A method that calculates and applies a steering force towards a target
// STEER = DESIRED MINUS VELOCITY
Boid.prototype.seek = function(_p5, target) {
	let desired = p5.Vector.sub(target, this.position); // A vector pointing from the location to the target
	// Normalize desired and scale to maximum speed
	desired.normalize();
	desired.mult(this.maxspeed);
	// Steering = Desired minus Velocity
	let steer = p5.Vector.sub(desired, this.velocity);
	steer.limit(this.maxforce); // Limit to maximum steering force
	return steer;
}

Boid.prototype.render = function(p5) {
	// Draw a triangle rotated in the direction of velocity
	let theta = this.velocity.heading() + p5.radians(90);
	p5.fill(255, 255, 255, 100);
	//p5.stroke(200);
	p5.push();
	p5.translate(this.position.x, this.position.y);
	p5.rotate(theta);
    p5.text(this.char, 0, 0)
	p5.pop();
}

// Separation
// Method checks for nearby boids and steers away
Boid.prototype.separate = function(_p5, boids) {
	let desiredseparation = 25.0;
	let steer = _p5.createVector(0, 0);
	let count = 0;
	// For every boid in the system, check if it's too close
	for (let i = 0; i < boids.length; i++) {
		let d = p5.Vector.dist(this.position, boids[i].position);
		// If the distance is greater than 0 and less than an arbitrary amount (0 when you are yourself)
		if ((d > 0) && (d < desiredseparation)) {
			// Calculate vector pointing away from neighbor
			let diff = p5.Vector.sub(this.position, boids[i].position);
			diff.normalize();
			diff.div(d); // Weight by distance
			steer.add(diff);
			count++; // Keep track of how many
		}
	}
	// Average -- divide by how many
	if (count > 0) {
		steer.div(count);
	}

	// As long as the vector is greater than 0
	if (steer.mag() > 0) {
		// Implement Reynolds: Steering = Desired - Velocity
		steer.normalize();
		steer.mult(this.maxspeed);
		steer.sub(this.velocity);
		steer.limit(this.maxforce);
	}
	return steer;
}

// Alignment
// For every nearby boid in the system, calculate the average velocity
Boid.prototype.align = function(_p5, boids) {
	let neighbordist = 50;
	let sum = _p5.createVector(0, 0);
	let count = 0;
	for (let i = 0; i < boids.length; i++) {
		let d = p5.Vector.dist(this.position, boids[i].position);
		if ((d > 0) && (d < neighbordist)) {
			sum.add(boids[i].velocity);
			count++;
		}
	}
	if (count > 0) {
		sum.div(count);
		sum.normalize();
		sum.mult(this.maxspeed);
		let steer = p5.Vector.sub(sum, this.velocity);
		steer.limit(this.maxforce);
		return steer;
	}
    else {
		return _p5.createVector(0, 0);
	}
}

// Cohesion
// For the average location (i.e. center) of all nearby boids, calculate steering vector towards that location
Boid.prototype.cohesion = function(_p5, boids) {
	let neighbordist = 50;
	let sum = _p5.createVector(0, 0); // Start with empty vector to accumulate all locations
	let count = 0;
	for (let i = 0; i < boids.length; i++) {
		let d = p5.Vector.dist(this.position, boids[i].position);
		if ((d > 0) && (d < neighbordist)) {
			sum.add(boids[i].position); // Add location
			count++;
		}
	}
	if (count > 0) {
		sum.div(count);
		return this.seek(_p5, sum); // Steer towards the location
	}
    else {
		return _p5.createVector(0, 0);
	}
}

// Wraparound
Boid.prototype.borders = function(p5) {
	if (this.position.x < -this.r) this.position.x = p5.width + this.r;
	if (this.position.y < -this.r) this.position.y = p5.height + this.r;
	if (this.position.x > p5.width + this.r) this.position.x = -this.r;
	if (this.position.y > p5.height + this.r) this.position.y = -this.r;
}

class Birds extends React.Component {
    constructor(props) {
        super(props)

        this.flock = null
	    this.chars = "abcdefghijklmnopqrstuvwxyz"
	    this.cPos = 0
        this.minFontSize = 14
	    this.fontSize = 14

		this.reset = this.reset.bind(this)
		this.setup = this.setup.bind(this)
		this.draw = this.draw.bind(this)
		this.windowResized = this.windowResized.bind(this)
    }

    componentDidMount() {
        this.props.onchangePoemInfo(strings)
    }

    nextCh() {
        var ch = this.chars.substring(this.cPos, this.cPos+1)
        this.cPos = (this.cPos + 1) % this.chars.length

        return ch
    }

    reset(p5) {
        p5.background(0)

        var maxSpeed = p5.random(2, 7)
        var maxForce = p5.random(0.025, 0.75)

        this.flock = new Flock();
        // Add an initial set of boids into the system
        for (let i = 0; i < 30; i++) {
            let ch = this.nextCh()
            let b = new Boid(p5, p5.width / 2, p5.height / 2, ch, maxSpeed, maxForce);
            this.flock.addBoid(b);
        }

        this.fontSize = Math.max(window.innerWidth / 60, this.minFontSize)

        p5.textFont("DejaVuSerif");
        p5.textSize(this.fontSize)
    }

	setup(p5, canvasParentRef) {
        p5.createCanvas(window.innerWidth, window.innerHeight).parent(canvasParentRef)
        this.reset(p5)
	}

	draw(p5) {
        if (this.flock !== undefined) {
            p5.background(0, 0, 0, 2)
            p5.textSize(this.fontSize)
            this.flock.run(p5);
        }
	}

	windowResized(p5) {
		p5.resizeCanvas(window.innerWidth, window.innerHeight)
    	this.reset(p5)
	}

	render() {
        strings.setLanguage(this.context.language)
		return <Sketch setup = {this.setup} draw = {this.draw} windowResized = {this.windowResized} />
	}
}
Birds.contextType = LanguageContext

export default Birds
